import _delay from 'lodash/delay';
import _find from 'lodash/find';
import _forEach from 'lodash/forEach';
import _get from 'lodash/get';
import _head from 'lodash/head';
import _isEmpty from 'lodash/isEmpty';
import _split from 'lodash/split';
import {
  WS_CODE_CLOSE_ABNORMAL,
  WS_TOPIC_ASYNC,
  WS_TOPIC_CONFIG,
  WS_TOPIC_CUSTOMERS,
  WS_TOPIC_DEVICE_SMS,
  WS_TOPIC_INSTALLATIONS,
  WS_TOPIC_ENTITIES,
  WS_TOPIC_PLANNINGS,
  WS_TOPIC_SCENARIOS,
  WS_TOPIC_SLAVES,
  ASYNC_OP_STATUS_SUCCESS,
  // ASYNC_OP_STATUS_PENDING,
  ASYNC_OP_TIMEOUT_MS,
} from '../constants/App';
import {
  REGISTER_ASYNC_OPERATION,
  WS_CLOSE,
  WS_RECEIVED_ASYNC_RESULT,
  WS_RECEIVED_OPERATION,
} from '../constants/ActionTypes';
import * as wsEvents from '../constants/WsEvents';
import {
  wsConnect, wsLeaveTopic,
  registerAsyncOperation, timeoutAsyncOperation, getDeviceSync,
} from '../actions';
// Models
import mAsync from '../models/async';

/*
** From Webpack Env Config
*/
const WS_RETRY_CONNECT_TIMER = __WS_RETRY_CONNECT_TIMER__; // eslint-disable-line no-undef

// Store timers for each async operation
const asyncOperationTimers = {};

const webSocketPostProcess = (store) => (next) => (action) => {
  // Get current state BEFORE calling next (because treatments done could modify store)
  const deviceDataElements = _get(store.getState(), 'deviceData.elements');

  next(action);

  let resourceKey;
  let asyncOperationId;
  let asyncOperationDevices;
  let device;

  switch (action.type) {
    case REGISTER_ASYNC_OPERATION:
      asyncOperationId = action.asyncOperation.id;

      // Start a timer to remove async operation in case of no result from WS is received
      asyncOperationTimers[asyncOperationId] = setTimeout(() => {
        store.dispatch(timeoutAsyncOperation(asyncOperationId));
      }, ASYNC_OP_TIMEOUT_MS);

      break;

    case WS_CLOSE:
      // When detecting abnormal closing of WS, try a new connection after a delay
      if (action.code === WS_CODE_CLOSE_ABNORMAL) {
        _delay(() => store.dispatch(wsConnect()), WS_RETRY_CONNECT_TIMER);
      }
      break;

    case WS_RECEIVED_ASYNC_RESULT:
      asyncOperationId = action.id;

      // Cancel timer for concerned async operation
      clearTimeout(asyncOperationTimers[asyncOperationId]);

      // Dispatch an action to leave the topic of this async operation
      store.dispatch(wsLeaveTopic(`${WS_TOPIC_ASYNC}:${asyncOperationId}`, asyncOperationId));

      // We need to update concerned devices sync status
      asyncOperationDevices = action.asyncOperation.devices;
      if (!_isEmpty(asyncOperationDevices)) {
        // Parse devices, and check for each if its data is registered
        _forEach(asyncOperationDevices, (asyncOperationDevice) => {
          device = _find(deviceDataElements, ['id', asyncOperationDevice.device_id]);
          // If the device is found and the async operation is in success: reload device sync status
          if (device && asyncOperationDevice.status === ASYNC_OP_STATUS_SUCCESS) {
            store.dispatch(getDeviceSync(device.id));
          }
        });
      }

      break;

    case WS_RECEIVED_OPERATION:
      if (action.operation === wsEvents.EVENT_INFO) {
        // Get topic
        switch (_head(_split(action.topic, ':'))) {
          case WS_TOPIC_DEVICE_SMS:
            // Check status of the SMS
            // If it is not in pending state, we can leave this topic
            if (action.payload && action.payload.data && action.payload.data.delivery_status !== 'pending') {
              store.dispatch(wsLeaveTopic(`${WS_TOPIC_DEVICE_SMS}:${action.payload.id}`, action.payload.id));
            }
            break;
          default:
            break;
        }
      } else if (action.operation !== wsEvents.EVENT_HEAD && action.topic && action.payload && action.payload.async_operation && action.payload.id) {
        resourceKey = null;
        // When we receive an operation (add/update/delete) on a resource, dispatch an event to join the corresponding
        // async operation topic
        switch (_head(_split(action.topic, ':'))) {
          case WS_TOPIC_CONFIG:
            resourceKey = 'idConfig';
            break;
          case WS_TOPIC_SLAVES:
            resourceKey = 'idSlave';
            break;
          case WS_TOPIC_INSTALLATIONS:
            resourceKey = 'idInstallation';
            break;
          case WS_TOPIC_ENTITIES:
            resourceKey = 'idEntity';
            break;
          case WS_TOPIC_SCENARIOS:
            resourceKey = 'idScenario';
            break;
          case WS_TOPIC_CUSTOMERS:
            resourceKey = 'idCustomer';
            break;
          case WS_TOPIC_PLANNINGS:
            resourceKey = 'idPlanning';
            break;
          default:
            break;
        }
        if (resourceKey) {
          // Create and register an async operation for the concerned resource
          store.dispatch(registerAsyncOperation(mAsync.createAsyncOperation(action.payload.async_operation, { key: resourceKey, id: action.payload.id })));
        }
      }
      break;

    default:
      break;
  }
};

export default webSocketPostProcess;



// WEBPACK FOOTER //
// ./middlewares/webSocketPostProcess.js